import React from "react";
// import QuestionIcon from "../../assets/images/question-icon.svg";
// import PointIcon from "../../assets/images/point-icon.svg";
import QuestionBar from "../../assets/images/question-bar.svg";
import classNames from "classnames";
import Ten from "../../assets/images/round-timer-10.svg"
import PointsBar from "../../assets/images/points-bar.svg";
import { motion } from "framer-motion";
import { MAX_SCORE, ROUND_TIMEOUT } from "../../config.js";
import { clampTime, formattedTime } from "../../utils";
import { time } from "console";

interface RoundHeaderProps {
  timeLeft: number;
  currentRound: number;
  totalRounds: number;
  playerScore: number;
}



export const RoundHeader = ({
  timeLeft,
  currentRound,
  totalRounds,
  playerScore
}: RoundHeaderProps) => {
  

const timerBg = [
  { 
    imageSrc: require("../../assets/images/round-timer-00.svg"),
  },
    { 
    imageSrc: require("../../assets/images/round-timer-01.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-02.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-03.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-04.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-05.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-06.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-07.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-08.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-09.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-10.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-10.svg"),
  },  { 
    imageSrc: require("../../assets/images/round-timer-10.svg"),
  },  
];



  return (
    <motion.div
      className="w-full items-center justify-center text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="game-bar">
        <div className="game-bar-questions">
          <div className="question-total">{currentRound}/{totalRounds}</div>
          <img src={QuestionBar} alt="Question Total" />
        </div>
        <div className="game-bar-time">
          
        <div className="round-time">{formattedTime(timeLeft)}</div>
          <img className={classNames({
            'hide-clock': formattedTime(timeLeft) > 10
          })} src={`${timerBg[timeLeft].imageSrc}`} alt="Round Timer"/>
          <img className={classNames({
            'hide-clock': formattedTime(timeLeft) <= 10
          })} src={Ten} alt=""/>
        </div>
        <div className="game-bar-points">
          <div className="point-total">{playerScore} Points</div>
          <img src={PointsBar} alt="Point Total" />
          {/* <div className="status-bar">
            <motion.div
              className="status-bar-indicator"
              animate={{ width: `${(playerScore / MAX_SCORE) * 100}%` }}
            ></motion.div>
            <div className="status-bar-total">{playerScore} Points</div>
          </div> */}
        </div>
      </div>
    </motion.div>
  );
};

export default RoundHeader;
